module.exports = __webpack_public_path__ + "static/media/003-austria.38e8c93c.svg";